import { render, staticRenderFns } from "./StudentMasterclasses.vue?vue&type=template&id=5fb27a00&"
import script from "./StudentMasterclasses.vue?vue&type=script&lang=js&"
export * from "./StudentMasterclasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports